export interface TokenSet {
  id: number;
  name: string;
  source: string;
  created_at: string;
  updated_at: string;
}

export interface TokenValue {
  $value: string | number | Record<string, unknown>;
  $type?: string;
  $description?: string;
}

export interface TokenGroup {
  $type?: string;
  $description?: string;
  [key: string]: string | TokenValue | TokenGroup | undefined;
}
